module.exports = __webpack_public_path__ + "img/Boy_020031.07c99c4e.png";